import React, { useState } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    addDoc,
    Timestamp
} from "firebase/firestore";
import { db } from "../../config/firebase";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routing/routes";
import { COLLECTION, SESSION } from "../../data/constant";
import Layout from "./Layout";
import { validateRequiredField, createInitialForm } from "../../common/common";

const GuardLoginData = {
    email: {
        key: "email",
        label: "Email",
        placeHolder: "Enter Guard Email",
        type: "email",
        isRequired: true,
    },
    password: {
        key: "password",
        label: "Password",
        placeHolder: "Enter Password",
        type: "password",
        isRequired: true,
    },
};

const GuardLogin = () => {
    const [loginState, setLoginState] = useState(createInitialForm(GuardLoginData));
    const [loginFailedText, setLoginFailedText] = useState("");
    const [errorFields, setErrorFields] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);

    const navigate = useNavigate();

    const getLoginInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        if (errorFields.includes(name) && ![undefined, null, ""].includes(value)) {
            setErrorFields((prevState) => prevState.filter((key) => key !== name));
        }
        setLoginState((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleLogin = async () => {
        console.log("Handle Login clicked");
        console.log("Current State:", loginState);
        const error = validateRequiredField(GuardLoginData, loginState);
        console.log("Validation Errors:", error);
        setErrorFields(error);

        if (error.length === 0) {
            try {
                setSubmitLoading(true);
                setLoginFailedText("");

                const q = query(
                    collection(db, COLLECTION.GUARDS),
                    where("email", "==", loginState.email)
                );

                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const docSnap = querySnapshot.docs[0];
                    const docData = { ...docSnap.data(), id: docSnap.id };

                    if (docData.password === loginState.password) {
                        // Login Success
                        // Create Session
                        const sessionRef = await addDoc(collection(db, COLLECTION.GUARD_SESSION), {
                            guardId: docData.id,
                            email: docData.email,
                            sessionStart: Timestamp.now(),
                        });

                        localStorage.setItem(SESSION.GUARD_SESSION_ID, sessionRef.id);
                        navigate(routes.GUARD_DASHBOARD);
                    } else {
                        setSubmitLoading(false);
                        setLoginFailedText("Incorrect Password");
                    }
                } else {
                    setSubmitLoading(false);
                    setLoginFailedText("No Guard account found with this email");
                }
            } catch (error) {
                console.error("Login Error:", error);
                setSubmitLoading(false);
                setLoginFailedText("An error occurred during login. Please try again.");
            }
        }
    };

    return (
        <Layout
            loginState={loginState}
            loginFailedText={loginFailedText}
            errorFields={errorFields}
            getLoginInput={getLoginInput}
            handleLogin={handleLogin}
            guardDataConfig={GuardLoginData}
        />
    );
};

export default GuardLogin;
